import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import checkNot from '../utils/checkNot';
import qs from '../utils/query';

export default class ConceptApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  // =============================================================================
  //                                  CONCEPT APIs
  // =============================================================================

  public ConceptShow(id: number | string) {
    const query = `/core/v1/concept/${id}`;
    return this.get(query, '');
  }

  public ConceptListSons(parentName: string) {
    const query = `/core/v1/${parentName}`;
    return this.get(query);
  }

  public ConceptListParents(conceptId: number) {
    const query = `/core/v3/concepts/${conceptId}/parents`;
    return this.get(query);
  }

  public ConceptSpecificListSons(parentId: number, filters: any) {
    const query = `/core/v1/concept/${parentId}/sons`;
    let parameters = '?alk=1';
    if (checkNot(filters.name, ['undefined', 'null', 'empty'])) {
      parameters += `&like_name=${filters.name}`;
    }
    if (checkNot(filters.only_children, ['undefined', 'null', 'empty'])) {
      parameters += `&only_children=${filters.only_children}`;
    }
    return this.get(query, parameters);
  }

  public ConceptUnitFridgeList(queries: any, limit?: number, offset?: number) {
    const query = '/core/v1/unitfridge';
    let parameters = '?alk=1';
    if (
      checkNot(queries.isconceptualizedby_id, ['undefined', 'null', 'empty'])
    ) {
      parameters += `&isconceptualizedby_id=${queries.isconceptualizedby_id}`;
    }
    if (checkNot(queries.include_general, ['undefined', 'null', 'empty'])) {
      parameters += `&include_general=${queries.include_general}`;
    }
    if (checkNot(limit, ['undefined', 'null', 'empty'])) {
      parameters += `&limit=${limit}`;
    }
    if (checkNot(offset, ['undefined', 'null', 'empty'])) {
      parameters += `&offset=${offset}`;
    }
    return this.get(query, parameters);
  }

  public ConceptGetByName(name: string, options: any) {
    const query = `/core/v3/concepts/${name}`;

    const parameters: any = {};
    if (checkNot(options.asTree, ['undefined', 'null', 'empty'])) {
      parameters.as_tree = options.asTree;
    }
    if (checkNot(options.includeParent, ['undefined', 'null', 'empty'])) {
      parameters.include_parent = options.includeParent;
    }
    if (checkNot(options.onlyVisible, ['undefined', 'null', 'empty'])) {
      parameters.only_visible = options.onlyVisible;
    }
    if (checkNot(options.onlyLeaves, ['undefined', 'null', 'empty'])) {
      parameters.only_leaves = options.onlyLeaves;
    }
    return this.get(query, qs.stringify(parameters, true));
  }

  public ConceptListV3(
    conceptType: string,
    filters: any,
    useCache: boolean = true,
  ) {
    const query = `/core/v3/concepts/${conceptType}`;

    const parameters: any = {};
    if (checkNot(filters.likeName, ['undefined', 'null', 'empty'])) {
      parameters.like_name = filters.likeName;
    }

    if (filters.onlyChildren) {
      parameters.only_children = filters.onlyChildren;
    }
    if (filters.onlyLeaves) {
      parameters.only_leaves = filters.onlyLeaves;
    }
    if (filters.onlyVisible) {
      parameters.only_visible = filters.onlyVisible;
    }
    if (filters.onlyInclude) {
      parameters.only_include = filters.onlyInclude;
    }
    if (filters.asTree) {
      parameters.as_tree = filters.asTree;
    }
    if (filters.includeParent) {
      parameters.include_parent = filters.includeParent;
    }

    return this.get(query, qs.stringify(parameters, true), useCache);
  }
}
